// src/context/FontContext.js (Yeni dosya)

import React, { createContext, useState, useContext } from 'react';

// Context'i oluştur
const FontContext = createContext();

// Hook: Diğer bileşenlerin kullanması için
export const useFont = () => useContext(FontContext);

// Provider bileşeni
export const FontProvider = ({ children }) => {
    // 🔥 İstenen state burada tanımlanır
    const [fontSize, setFontSize] = useState(16); 

    // Büyütme ve küçültme fonksiyonları
    const increaseFontSize = () => {
        setFontSize(prev => Math.min(prev + 2, 24)); // Maksimum 24
    };

    const decreaseFontSize = () => {
        setFontSize(prev => Math.max(prev - 2, 14)); // Minimum 14
    };

    return (
        <FontContext.Provider value={{ fontSize, setFontSize, increaseFontSize, decreaseFontSize }}>
            {children}
        </FontContext.Provider>
    );
};